import { mapData } from "@/utilities/DataMapping";

export enum RequirementType {
    Optional = 0,
    Mandatory = 1,
    Hidden = 2
}

export interface IStandardRegistrationField {
    columnName: string;
    label: string;
    isMandatory: boolean;
    isHidden: boolean;
}

export class StandardRegistrationField implements IStandardRegistrationField {

    constructor(data?: IStandardRegistrationField) {
        if (data) this.update(data);
    }

    update(data: IStandardRegistrationField): StandardRegistrationField {
        mapData(data, { root: () => this });
        return this;
    }

    columnName: string = "";
    label: string = "";
    isMandatory: boolean = false;
    isHidden: boolean = false;

    get requirement(): RequirementType {
        if(this.isMandatory) return RequirementType.Mandatory;
        if(this.isHidden) return RequirementType.Hidden;
        return RequirementType.Optional;
    }
    set requirement(value: RequirementType) {
        if(value === RequirementType.Mandatory) {
            this.isHidden = false;
            this.isMandatory = true;
        }
        else if(value === RequirementType.Hidden) {
            this.isHidden = true;
            this.isMandatory = false;
        }
        else {
            this.isHidden = false;
            this.isMandatory = false;
        }
    }
}
